import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './workOrderViewHeader.scss'

function WorkOrderViewHeader({ logo, alt }) {
  const [hasError, setHasError] = useState(false)
  return logo && !hasError ? (
    <header className="work-order-header">
      <img alt={alt} src={logo} className="work-order-header__logo" onError={() => setHasError(true)} />
    </header>
  ) : null;
}

WorkOrderViewHeader.propTypes = {
  logo: PropTypes.string,
  alt: PropTypes.string,
}

export default WorkOrderViewHeader
